import {
  GET_CAR_DELIVERIES,
  GET_CAR_DELIVERIES_SUCCESS,
  GET_CAR_DELIVERIES_FAIL,
  GET_CAR_DELIVERY_DETAILS,
  GET_CAR_DELIVERY_DETAILS_SUCCESS,
  GET_CAR_DELIVERY_DETAILS_FAIL,
  CREATE_CAR_DELIVERY,
  CREATE_CAR_DELIVERY_SUCCESS,
  CREATE_CAR_DELIVERY_FAIL,
  UPDATE_CAR_DELIVERY,
  UPDATE_CAR_DELIVERY_SUCCESS,
  UPDATE_CAR_DELIVERY_FAIL,
  DELETE_CAR_DELIVERY,
  DELETE_CAR_DELIVERY_SUCCESS,
  DELETE_CAR_DELIVERY_FAIL,
 
} from "./actionTypes"

const INIT_STATE = {

  deliveries: {
    deliveries: [],
    total: "",
    page: "",
  },
  carDeliveryDetails: {},
  error: {},
  loading: false,
}

const CarDelivery = (state = INIT_STATE, action) => {
  switch (action.type) {
    // CarDelivery - This line cannot be edited or removed
    case GET_CAR_DELIVERIES:
    case GET_CAR_DELIVERY_DETAILS:
    case CREATE_CAR_DELIVERY:
    case UPDATE_CAR_DELIVERY:
    case DELETE_CAR_DELIVERY:
      return {
        ...state,
        loading: true,
      }

    case DELETE_CAR_DELIVERY_FAIL:
    case GET_CAR_DELIVERIES_FAIL:
    case GET_CAR_DELIVERY_DETAILS_FAIL:
    case UPDATE_CAR_DELIVERY_FAIL:
    case CREATE_CAR_DELIVERY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_CAR_DELIVERIES_SUCCESS:
      return {
        ...state,
        deliveries: action.payload,
        error: {},
        loading: false,
      }

    case GET_CAR_DELIVERY_DETAILS_SUCCESS:
      return {
        ...state,
        carDeliveryDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_CAR_DELIVERY_SUCCESS:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          deliveries: [action.payload, ...state.deliveries.deliveries],
          total: state.deliveries.total + 1,
        },
        carDeliveryDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_CAR_DELIVERY_SUCCESS:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          deliveries: state.deliveries.deliveries.map(client =>
            client._id === action.payload._id
              ? { ...client, ...action.payload }
              : client
          ),
        },
        carDeliveryDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_CAR_DELIVERY_SUCCESS:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          deliveries: state.deliveries.deliveries.filter(
            client => client._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    default:
      return state
  }
}

export default CarDelivery
